<template>
  <v-form v-model="isFormValid" ref="form">
    <div>
      <dashboard-header :text="item ? $t('ui.updateAlarm'): $t('ui.creatAlarm')" :on-back="onGoBack"/>
      <div class="d-flex justify-center align-center">
        <v-card elevation="0"
                class="card-border-10 w-75">
          <v-card class="m-4"
                  outlined>
            <div class="d-flex custom-card-head p-4">
              <div class="d-inline text-sm-h5 ">{{ $t("nav.about") }}</div>
            </div>
            <v-divider class="m-0"></v-divider>
            <div class="px-6 pt-6">
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('nav.sosMessage') }}</p>
              </div>
              <v-textarea
                  v-model="sosMessage.message"
                  :placeholder="placeholderName"
                  :rules="ruleMessageName"
                  counter="100"
                  rows="1"
                  auto-grow
                  outlined
              >
              </v-textarea>
            </div>
          </v-card>
          <div class=" m-4">
            <v-btn
                elevation="0"
                :disabled="!isFormValid"
                class="no-uppercase btn-custom-primary"
                @click="onSave"
            >{{ $t('ui.save') }}
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>
  </v-form>

</template>

<script>
import DashboardHeader from "../component/DashboardHeader";
import {API2} from "../../api";
import mixin from "../../mixin";
import i18n from "../../lang/i18n";

export default {
  name: "CreateOrUpdate",
  components: {DashboardHeader},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      sosMessage: this.getDefaultSosMessage(),
      isFormValid: false
    }
  },
  mounted() {
    this.onTab(this.item)
  },
  computed: {
    ruleMessageName() {
      return [
        this.sosMessage.message.length > 0 && this.sosMessage.message.length <= 100 || this.$t("ui.MSG0101"),
        this.sosMessage.message.trim().length > 0 || this.$t("ui.MSG0101")
      ];
    },
    placeholderName() {
      return this.$t('ui.enterAlarmContent')
    },
  },
  methods: {
    onGoBack() {
      this.openTab(0)
    },
    onTab(item) {
      this.$refs.form.resetValidation()
      this.sosMessage = this.getDefaultSosMessage()
      if (item) this.getData(item)
    },
    getDefaultSosMessage() {
      return {
        message: '',
      };
    },
    async getData(item) {
      let res = await this.get(API2.SOS_MESSAGE, {path: item.data.messageId})
      if (res) {
        this.sosMessage = res
      } else {
        // No data found, go back to previous screen
        this.onGoBack();
      }
    },
    async onSave() {
      let data = {
        message: this.sosMessage.message,
      }
      if (this.item) {
        data.path = this.sosMessage.messageId
      }
      let res = this.item ? await this.put(API2.SOS_MESSAGE, data) : await this.post(API2.SOS_MESSAGE, data)
      if (!res) return
      this.showToast("success", i18n.t("base.notification"), i18n.t("base.updateSuccessful"))
      this.openTab(0)
    },
  },
}
</script>

<style scoped>

.v-input {
  font-size: 22px;
}

.card-border-10 >>> .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(217, 217, 217, 1);
}

</style>